import { Box, Input } from "@mui/material";
import { AsyncImage } from "loadable-image";
import React, { useEffect, useMemo, useState } from "react";
import "./longCard.css";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { getIcon } from "utils/iconsConfig";
import Tooltip from "../Tooltip";
import Card from "../Card";
import ImageModal from "../ImageModal";
import { useFilter } from "context/FilterContext";
import { useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import { useGlobalContext } from "context/GlobalContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import watermarkImageUrl from "../../../assets/img/watermark.png";
import RelevantSetModal from "../CenterModal/RelevantSetModal";
import LongCardSkeleton from "../Skeleton/longCardSkeleton";
import useItemSizes from "hooks/useItemSizes";
import { useDispatch, useSelector } from "react-redux";
import { initCart } from "store/cartSlice";
import { getProductIcon } from "assets/productIcon/Products";

const LongCard = ({ data, setIcon, RemoveDesign, invalidStyleNumbers, setInvalidStyleNumbers, fromModal, onUpdate, sizeData, isLoading, cartItemId }) => {
  const permission = usePermissions();
  const resolveIcon = (type) => {
    if (!type) return null;
    return getProductIcon(type);
  };

  const { filterValues, filterCount, setFilterValues } = useFilter();
  const [details, setDetails] = useState([]);
  const [imageData, setImageData] = useState({});
  const [message, setMessage] = useState(data?.message);
  // const [itemPoNo, setItemPONo] = useState(data?.itemPoNo);
  const [poNumber, setPoNumber] = useState(data?.itemPoNo);
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [rhodium, setRhodium] = useState(data?.rhodium);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [size, setSize] = useState("Select Size");
  const [goldQlty, setGoldQlty] = useState();

  const [diamondQlty, setDiamondQlty] = useState(null);
  const [updateMassage, setUpdateMassage] = useState(false);
  const [updatePoNumber, setupdatePoNumber] = useState(false);

  const [openRelevantModal, setOpenRelevantModal] = useState(false);
  const [selectedRelevantDesigns, setSelectedRelevantDesigns] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(null);

  const { setCartData } = useGlobalContext();

  const dispatch = useDispatch();

  const cartData = useSelector((state) => state.cart.cartData);

  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === cartData?.length - 1 || cartData?.length === 0;
  const isInvalid = invalidStyleNumbers?.includes(data.styleNumber);

  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;;

  const defaultGoldQty = ["18", "18", "18", "14", "14", "14"];
  const defaultGoldColor = ["P", "W", "Y", "P", "W", "Y"];

  const defaultDiamondData = ["VVS-EF", "VVS-FG", "VVS-GH", "VS-GH", "VSSI-GH", "SI-HI", "SI-IJ"];

  const [imageModal, setImageModal] = useState(false);
  const goldforSteel = data?.categoryName?.toLowerCase()?.includes("steel");

  //** Code for Showing Set Icon Color  **//
  const shouldShowWhiteSetIcon = () => {
    if (!Array.isArray(setIcon) || setIcon.length === 0) return false;
    if (!Array.isArray(cartData) || cartData.length === 0) return false;

    const mismatchedDesigns = setIcon
      .map((styleNumber) => {
        const matchedCartDesign = cartData.find((item) => item.styleNumber === styleNumber);
        if (!matchedCartDesign) return false;
        const currentGoldQlty = `${matchedCartDesign.goldQlty}-${matchedCartDesign.goldColor}`;
        const changedGoldQlty = goldQlty;

        const isMismatch =
          // matchedCartDesign.itemSize !== size ||
          currentGoldQlty !== changedGoldQlty || matchedCartDesign.diaQlty !== diamondQlty;
        // || (matchedCartDesign.message || "") !== (message || "");

        return isMismatch;
      })
      .filter(Boolean);

    return mismatchedDesigns.length > 0;
  };

  const iconVariant = useMemo(() => {
    const shouldShowWhite = shouldShowWhiteSetIcon();
    return shouldShowWhite ? "black" : "default";
  }, [goldQlty, diamondQlty, cartData]);

  //** Code for Showing Set Icon Color  **//

  //** Handle Set Icon Click  **//

  const handleRelevantSetClick = (relevantDesigns) => {
    setSelectedRelevantDesigns(relevantDesigns);
    setOpenRelevantModal(true);
  };

  //** Handle Relevant set modal Apply Btn  **//

  const handleRelevantSetChanges = (updatedDesigns) => {
    const cartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
    const removedStyleNumbers = JSON.parse(sessionStorage.getItem("TempRemovedModalDesigns")) || [];

    let updatedCart = cartData.filter((item) => !removedStyleNumbers.includes(item.styleNumber.toString()));

    updatedDesigns.forEach((updatedDesign) => {
      updatedCart = updatedCart.map((item) => (item.styleNumber === updatedDesign.styleNumber ? updatedDesign : item));
    });

    setCartData([]);

    // Reason using SetTime Out is (Session data overwritting old values )
    setTimeout(() => {
      sessionStorage.setItem("CartData", JSON.stringify(updatedCart));
      setCartData(updatedCart);
    }, 0);

    sessionStorage.removeItem("TempRemovedModalDesigns");
    setOpenRelevantModal(false);
  };

  //** Handle Open Relevant Set Modal **//

  const handleCloseRelevantModal = () => {
    setOpenRelevantModal(false);
    sessionStorage.removeItem("TempRemovedModalDesigns");
  };
  //console.log( "ladle meauuuuuu",data);

  const showDetails = useMemo(
    () => [
      {
        left: [
          {
            label: data?.styleNumber,
            Icon: getIcon(`${data?.designClass}CartOrder`),
            tooltipTitle: null,
          },
          ...(goldforSteel
            ? []
            : [
                {
                  label: `${data.weight || `0 g / 0 g`} `,
                  Icon: getIcon("goldbarCartOrder"),
                  tooltipTitle: "Gold Net Weight / Gold Gross Weight",
                },
              ]),
          {
            label: `${data?.diamond || `0 Ct / 0 Pcs`}`,
            Icon: getIcon("diamondCartOrder"),
            tooltipTitle: "Diamond Weight / Diamond Pieces",
          },
          { label: `${data?.colorStoneWeight} Ct / ${data?.colorStonePcs} Pcs`, Icon: resolveIcon("gemstone", "white"), tooltipTitle: "ColorStone Weight / ColorStone Pieces" },
          {
            label: `${data?.otherMaterialWeight} g / ${data?.otherMaterialPcs} Pcs`,
            Icon: resolveIcon("otherMaterial", "white"),
            tooltipTitle: "OtherMaterial Weight / OtherMaterial Pieces",
          },
          {
            label: data?.sales,
            Icon: resolveIcon("sales", "white"),
            tooltipTitle: "Sales",
          },
          {
            label: data?.date,
            Icon: resolveIcon("date", "white"),
            tooltipTitle: "Design Creation Date",
          },
        ],
      },
      {
        middle: [
          ...(setIcon?.length > 0
            ? [
                {
                  // Icon: getIcon("setCartOrder"),
                  Icon: getIcon("setCartOrder", iconVariant),
                  tooltipTitle: "Sets",
                },
              ]
            : []),
        ],
      },
    ],
    [data]
  );

  const rhodiumMap = {
    White: "W",
    Yellow: "Y",
    Pink: "P",
  };

  const reverseRhodiumMap = Object.fromEntries(Object.entries(rhodiumMap).map(([key, value]) => [value, key]));

  function handleColorKarat(goldcolor, goldkarat) {
    const colorMap = {
      "White Gold": "W",
      W: "W",
      "Rose Gold": "P",
      P: "P",
      "Yellow Gold": "Y",
      Y: "Y",
    };

    const karatMap = {
      "14K": "14",
      14: "14",
      "18K": "18",
      18: "18",
    };

    const color = colorMap[goldcolor];
    const karat = karatMap[goldkarat];

    return `${karat}-${color}`;
  }

  let bgColor = "#000";
  let fontColor = "#fff";

  if (rhodium === "Y") {
    bgColor = "#171300";
    fontColor = "#FFD700";
  } else if (rhodium === "W") {
    bgColor = "#262626";
    fontColor = "#fff";
  } else if (rhodium === "P") {
    bgColor = "#150814";
    fontColor = "#E77B7B";
  }

  useEffect(() => {
    const goldQlty = (value) => value?.split("K")[0];
    const goldColor = (value) => value?.[0]?.toUpperCase() ?? "";

    const ModifyDiaQlty = (value) => {
      if (value?.includes("-") || value == null) return value;
      return (value ?? "-").replace(/(.+)(..)$/, "$1-$2");
    };

    const isBracelet = ["Gents Bracelets", "Ladies Bracelets"].includes(data?.categoryName);

    const isSpecialKada = ["Oval Kada", "Sardar Kada"].includes(data?.subCategoryName);

    const getValidSize = (incomingSize) => {
      if (!incomingSize) return "";

      if (!isBracelet) return incomingSize;

      if (isSpecialKada) {
        return incomingSize.includes("ANI") ? incomingSize : "";
      } else {
        return incomingSize.includes("CM") ? incomingSize : "";
      }
    };

    const resolveRhodiumCode = (incoming) => {
      if (!incoming) return null;
      // Accept either label ("White") or code ("W")
      if (incoming === "W" || incoming === "Y" || incoming === "P") return incoming;
      return rhodiumMap[incoming] || null;
    };

    // Always start from item defaults to avoid blank controls.
    setGoldQlty(`${goldQlty(data.goldQlty)}-${goldColor(data.goldColor)}` || "18-P");
    setDiamondQlty(ModifyDiaQlty(data.diaQlty) || "VS-GH");
    setSize(data.itemSize || "Select Size");
    setMessage(data?.message);
    setPoNumber(data?.itemPoNo);

    const hasGoldFilter = Boolean(filterValues?.["Gold Color"]?.[0] && filterValues?.["Gold Purity"]?.[0]);
    const hasDiamondFilter = Boolean(filterValues?.["Diamond Quality"]?.[0]);
    const hasRhodiumFilter = Boolean(filterValues?.Rhodium?.[0]);

    if (filterValues?.categoriesName?.length > 0 && filterValues.categoriesName.includes(data?.categoryName)) {
      if (hasGoldFilter) {
        setGoldQlty(handleColorKarat(filterValues["Gold Color"][0], filterValues["Gold Purity"][0]));
      }
      if (hasDiamondFilter) {
        setDiamondQlty(filterValues["Diamond Quality"][0]);
      }
      if (hasRhodiumFilter) {
        const rhodiumCode = resolveRhodiumCode(filterValues?.Rhodium?.[0]);
        if (rhodiumCode) setRhodium(rhodiumCode);
      }

      if (filterValues.size && filterValues.categoriesName.length === 1 && filterValues.categoriesName[0] === data.categoryName) {
        const validSize = getValidSize(filterValues.size);
        if (validSize) {
          setSize(validSize);
        }
      }
    } else if (filterValues?.categoriesName?.length === 0 && Number(filterCount) > 0) {
      if (hasGoldFilter) {
        setGoldQlty(handleColorKarat(filterValues["Gold Color"][0], filterValues["Gold Purity"][0]));
      }
      if (hasDiamondFilter) {
        setDiamondQlty(filterValues["Diamond Quality"][0]);
      }
      if (hasRhodiumFilter) {
        const rhodiumCode = resolveRhodiumCode(filterValues?.Rhodium?.[0]);
        if (rhodiumCode) setRhodium(rhodiumCode);
      }
    }
  }, [filterValues, filterCount]);

  useEffect(() => {
    setDetails(showDetails);
    setImageData(data);
  }, [showDetails, data, goldforSteel]);

  const handleOpenImageModal = React.useCallback((imgUrl, designNo) => {
    setImageModal(true);
  }, []);

  useEffect(() => {
    if (isLoading) return;
    if (!sizeData) return;

    let updated = { ...data };

    const itemSize = size === "Select Size" ? null : size;
    const sizeAvailable = sizeData?.length > 0 && itemSize === null;

    updated.itemSize = itemSize;
    updated.sizeAvailable = sizeAvailable;
    updated.sizeData = sizeData?.length > 0 ? sizeData : [];

    if (size !== "Select Size" && invalidStyleNumbers?.includes(data?.styleNumber)) {
      const newInvalid = invalidStyleNumbers.filter((styleNo) => styleNo !== data.styleNumber);
      setInvalidStyleNumbers(newInvalid);
    }

    if (goldQlty) {
      let splitData = goldQlty?.split("-");
      updated.goldQlty = splitData[0];
      updated.goldColor = splitData[1];
    }

    if (rhodium) {
      updated.rhodium = rhodium;
    }

    if (diamondQlty) {
      updated.diaQlty = diamondQlty;
    }

    if (updateMassage) {
      updated.message = message ? message?.trim() : "";
    }
    if (updatePoNumber) {
      updated.itemPoNo = poNumber ? poNumber.trim() : "";
    }

    if (fromModal) {
      onUpdate(updated);
    } else {
      let getCartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
      // const newCartData = getCartData.map((item) => (item?.styleNumber === data?.styleNumber ? updated : item));

      const newCartData = getCartData.map((item, index) => (item?.cartItemId === cartItemId ? updated : item));

      sessionStorage.setItem("CartData", JSON.stringify(newCartData));
      setCartData(newCartData);
      dispatch(initCart());
    }
  }, [goldQlty, diamondQlty, rhodium, updateMassage, updatePoNumber, size, sizeData, fromModal, isLoading]);

  //----------- Code To Handle Image Modal Arrow Functionality  -------------------------\\

  const handleNextClick = () => {
    if (currentIndex < cartData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = cartData[newIndex];
      setImageData(nextItem);
      setImageModal(true);
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = cartData[newIndex];
      setImageData(prevItem);
      setImageModal(true);
    }
  };
  const rhodiumOptions = ["White", "Pink", "Yellow"];

  useEffect(() => {
    if (cartData?.length && data?.styleNumber) {
      const index = cartData.findIndex((item) => item?.styleNumber === data?.styleNumber);
      setCurrentIndex(index);
    }
  }, [cartData]);

  if (isLoading) {
    return <LongCardSkeleton />;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          rowGap: ".1vw",
          background: "#0D0D0D",
          width: "47.5vw",
          height: "12vw",
          padding: ".75vw",
          borderRadius: ".25vw  ",
          justifyContent: "space-between",
        }}
      >
        <Card
          width="17vw"
          height="9.5vw"
          style={{
            borderRadius: ".35vw",
            border: ".05vw solid #C0C0C0",
            cursor: "auto",
            padding: ".5vw",
            background: "#0D0D0D",
            height: "10.5vw",
            width: "18.2vw",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: ".28vw ",
            }}
            width={"100%"}
            height={"100%"}
          >
            <Box className="left-Create-Order">
              {details[0]?.left?.map((detail, index) => (
                <Box key={index} className={`long-content-new-Create-Order long-content-new-Create-Order-${index}`}>
                  {detail.Icon}
                  <Tooltip title={detail?.tooltipTitle}>
                    <div className={`long-content-typo long-content-typo-${index}`} ml={".5vw"}>
                      {detail.label}
                    </div>
                  </Tooltip>
                </Box>
              ))}
            </Box>
            {/* Set Icon */}
            {/* <Box className="middle-Create-Order">
              {details[1]?.middle?.map((detail, index) => (
                <React.Fragment key={index}>
                  <Box sx={{ cursor: "pointer" }} className={`content-new-Create-Order content-new-Create-Order-${index}`} onClick={onSetIconClick}>
                    <Tooltip title={detail?.tooltipTitle}>{detail?.Icon}</Tooltip>
                  </Box>
                </React.Fragment>
              ))}
            </Box> */}

            <Box className="middle-Create-Order">
              {setIcon?.length > 0 && (
                <Box sx={{ cursor: "pointer" }} className="content-new-Create-Order content-new-Create-Order-0" onClick={() => handleRelevantSetClick(data.relavantSetsDesign)}>
                  <Tooltip title="Sets">
                    {getIcon("setCartOrder", iconVariant)} {/* dynamic variant */}
                  </Tooltip>
                </Box>
              )}
            </Box>

            <Box sx={{ position: "relative" }}>
              <AsyncImage
                className="long-card-image-Create-Order"
                src={data.img || Image}
                alt={data.styleNumber}
                onClick={() => handleOpenImageModal(data.Orgimg ? data.Orgimg : null, data.styleNumber)}
              />
              {hasAccessToSeeWatermark && (data?.img || Image) && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "95%",
                    height: "95%",
                    backgroundImage: `url(${watermarkImageUrl})`,
                    backgroundRepeat: "repeat",
                    backgroundSize: "200px 200px",
                    opacity: 1,
                    pointerEvents: "none",
                  }}
                />
              )}
              <ImageModal
                open={imageModal}
                handleClose={() => setImageModal(false)}
                data={imageData}
                nextClick={() => handleNextClick()}
                prevClick={() => handlePrevClick()}
                hasNext={!isLastItem}
                hasPrev={!isFirstItem}
              />
            </Box>
          </Box>
        </Card>
        <div style={{ width: "100%", position: "relative", margin: ".5vw" }}>
          <div style={{ position: "absolute", top: -10, right: -10, cursor: "pointer" }} onClick={() => RemoveDesign(data)}>
            {getIcon("DeleteIcon")}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: ".5vw",
              // marginTop: ".5vw",
              width: "100%",
            }}
          >
            {/* Item Size */}

            <div style={{ display: "flex", gap: "15px" }}>
              <div
                className="filter-select"
                id={`size-select-${data.styleNumber}`}
                style={{
                  border: isInvalid && sizeData?.length > 0 ? "0.05vw solid #F23D3D" : "0.05vw solid #262626",
                }}
              >
                <label htmlFor="">{getIcon("blackScaleCartOrder")}</label>
                <select
                  value={size}
                  onChange={(e) => setSize(e.target.value)}
                  onFocus={() => setIsDropdownOpen(true)}
                  onBlur={() => setIsDropdownOpen(false)}
                  style={{
                    color: isInvalid && sizeData?.length > 0 ? "#F23D3D" : "white",
                  }}
                >
                  <option value="Select Size" hidden>
                    {size && size !== "Select Size" ? size : sizeData?.length === 0 ? "N/A" : "Select Size"}
                  </option>
                  {sizeData?.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                {sizeData?.length > 0 ? (
                  <span
                    style={{
                      transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                    className="down-label"
                  >
                    {getIcon("DownArrow")}
                  </span>
                ) : null}
              </div>

              {/*Item color*/}

              <div className="filter-select color-select" id={`color-select-${data.styleNumber}`}>
                <div>
                  <label>{getIcon("RhoidumIcon")}</label>
                </div>

                <div className="custom-select-value" onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)} style={{ background: bgColor, color: fontColor }}>
                  {reverseRhodiumMap[rhodium]}
                </div>

                {isColorDropdownOpen && (
                  <ul className="custom-options">
                    {rhodiumOptions.map((c) => (
                      <li
                        key={c}
                        onClick={() => {
                          setRhodium(rhodiumMap[c]);
                          setIsColorDropdownOpen(false);
                        }}
                      >
                        {c}
                      </li>
                    ))}
                  </ul>
                )}

                <span
                  style={{
                    transform: isColorDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                  className="down-label"
                >
                  {getIcon("DownArrow")}
                </span>
              </div>
            </div>

            {/* Gold QTY */}
            {!goldforSteel && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  borderRadius: ".25vw",
                  height: "1.5vw",
                  border: ".05vw solid #262626",

                  borderRight: "none",
                  overflowY: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#000",
                    padding: "0 .25vw",
                    height: "100%",
                    borderTopLeftRadius: ".25vw",
                    borderBottomLeftRadius: ".25vw",
                  }}
                >
                  {getIcon("goldCartOrder", "black")}
                </Box>
                <ToggleButtonGroup
                  color="primary"
                  exclusive
                  value={goldQlty}
                  onChange={(e, value) => value && setGoldQlty(value)}
                  sx={{
                    width: "100%",
                    height: "100%",
                    "& .MuiToggleButton-root:first-child": { borderRadius: 0 },
                    "& .MuiToggleButton-root": {
                      borderTop: "none",
                      borderBottom: "none",
                      borderLeft: "0.5px solid #262626",
                    },
                  }}
                >
                  {defaultGoldQty.map((qty, index) => {
                    const color = defaultGoldColor[index];

                    let bgColor = "#000";
                    let fontColor = "#fff";

                    if (color === "Y") {
                      bgColor = "#171300";
                      fontColor = "#FFD700";
                    } else if (color === "W") {
                      bgColor = "#262626";
                      fontColor = "#fff";
                    } else if (color === "P") {
                      bgColor = "#150814";
                      fontColor = "#E55CE3";
                    }

                    const displayValue = `${qty}-${color}`;

                    return (
                      <ToggleButton
                        key={displayValue}
                        value={displayValue}
                        style={{
                          fontSize: ".6vw",
                          fontFamily: "Karla",
                          fontWeight: "700",
                          whiteSpace: "nowrap",
                          background: goldQlty === displayValue ? bgColor : "#000",
                          color: goldQlty === displayValue ? fontColor : "#fff",
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                        }}
                      >
                        {displayValue}
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>
            )}
            {/* Diamond Qty */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "1.5vw",
                borderRadius: ".25vw",
                border: ".05vw solid #262626",
                overflowY: "hidden",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  background: "#000",
                  padding: "0px .25vw",
                  height: "100%",
                  borderTopLeftRadius: ".25vw",
                  borderBottomLeftRadius: ".25vw",
                }}
              >
                {getIcon("diamondCartOrder", "black")}
              </Box>
              <ToggleButtonGroup
                color="primary"
                exclusive
                value={diamondQlty}
                onChange={(e, value) => value && setDiamondQlty(value)}
                sx={{
                  width: "100%",
                  height: "100%",
                  "& .MuiToggleButton-root:first-child": { borderRadius: 0 },
                  "& .MuiToggleButton-root": {
                    borderTop: "none",
                    borderBottom: "none",
                    borderLeft: "0.5px solid #262626",
                  },
                }}
              >
                {defaultDiamondData.map((platform, index) => {
                  return (
                    <ToggleButton
                      key={platform}
                      value={platform}
                      style={{
                        fontSize: ".6vw",
                        fontFamily: "Karla",
                        fontWeight: "700",
                        whiteSpace: "nowrap",
                        background: diamondQlty === platform ? "#07120B" : "#000",
                        color: diamondQlty === platform ? "#50C878" : "#fff",
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                      }}
                    >
                      {platform}
                    </ToggleButton>
                  );
                })}
              </ToggleButtonGroup>
            </div>
            {/* Msg */}

            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: ".5vw",
                  width: "100%",
                }}
              >
                <input
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setUpdateMassage(false);
                  }}
                  onBlur={() => {
                    setUpdateMassage(true);
                  }}
                  style={{
                    height: "1.4vw",
                    width: "100%",
                    fontSize: ".5vw",
                    fontWeight: message ? "500" : "600",
                    fontFamily: "Karla",
                    padding: ".25vw",
                    background: "#000",
                    color: message ? "#EDEDEB" : "#333333",

                    borderRadius: ".25vw",
                    cursor: "pointer",
                    alignContent: "center",
                    border: "none",
                  }}
                  placeholder="Enter your message"
                  className="custom-input"
                />
              </div>
            </div>

            {/*PO No*/}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                background: "#000",
                borderRadius: ".25vw",
                border: ".05vw solid #262626",
                padding: "0 .25vw",
                height: "1.4vw",
                //  borderRight: "none",
                overflowY: "hidden",
                color: "#EDEDEB",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#EDEDEB",
                  marginRight: ".25vw",
                  height: "100%",
                  paddingRight: "0.25vw",
                  userSelect: "none",
                  borderRight: ".05vw solid #555",
                  pointerEvents: "none",
                  borderTopLeftRadius: ".25vw",
                  borderBottomLeftRadius: ".25vw",
                }}
              >
                {getIcon("Location_Icon", "black")}
              </Box>

              <input
                autoFocus={true}
                value={poNumber}
                onChange={(e) => {
                  setPoNumber(e.target.value);
                  setupdatePoNumber(false);
                }}
                onBlur={() => {
                  setupdatePoNumber(true);
                }}
                style={{
                  flex: 1,
                  height: "100%",
                  fontSize: ".5vw",
                  fontWeight: poNumber ? "500" : "600",
                  fontFamily: "Karla",
                  background: "transparent",
                  color: "#EDEDEB",
                  border: "none",
                  outline: "none",
                  paddingLeft: 0,
                  cursor: "pointer",
                }}
                placeholder="Enter Item PO No."
                className="custom-input"
              />
            </div>
          </div>
        </div>
      </div>

      <RelevantSetModal
        openModal={openRelevantModal}
        handleClose={handleCloseRelevantModal}
        selectedRelevantDesigns={selectedRelevantDesigns}
        cartDesigns={cartData}
        updateChanges={handleRelevantSetChanges}
      />
    </>
  );
};

export default LongCard;
